import { SVG, SVGProps } from './svg'

export function IconToolMidlineH(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M17.94 16.5a2 2 0 01-3.88 0 .5.5 0 01-.06 0H5a.5.5 0 010-1h9a.5.5 0 01.06 0 2 2 0 013.88 0 .5.5 0 01.06 0h9a.5.5 0 010 1h-9a.5.5 0 01-.06 0zM17 16a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
